import styled from '@emotion/styled';
import {Link} from '@chakra-ui/react';

export const StyledLink = styled(Link)`
	&:hover {
		text-decoration: none;
	}
`;
